import type { HttpClient } from "../http";
import type {
  AddStopRequest,
  CreateRouteRequest,
  RouteDTO,
  StopOutcomeRequest,
} from "../types";

export function routesResource(http: HttpClient) {
  return {
    list: () => http.get<RouteDTO[]>("/routes"),
    get: (id: number) => http.get<RouteDTO>(`/routes/${id}`),
    create: (body: CreateRouteRequest) => http.post<RouteDTO>("/routes", body),
    addStop: (id: number, body: AddStopRequest) =>
      http.post<RouteDTO>(`/routes/${id}/stops`, body),
    dispatch: (id: number) => http.post<RouteDTO>(`/routes/${id}/dispatch`),
    recordOutcome: (id: number, stopId: number, body: StopOutcomeRequest) =>
      http.post<RouteDTO>(`/routes/${id}/stops/${stopId}/outcome`, body),
  };
}
